(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      #observedSection = null;
      static observer = null;
      static sectionToItem = new Map();
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
        this.sections = null;
      }

      connectedCallback() {
        this.sections = document.querySelectorAll('#main .shopify-section');
        this.addEventListener('click', this.itemClick);

        const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
        if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

        const section = this.sections[sectionNumber - 1];
        if (!section) return;

        this.#observedSection = section;
        YGAnchorItem.#ensureObserver();
        YGAnchorItem.sectionToItem.set(section, this);
        YGAnchorItem.observer.observe(section);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);

        if (this.#observedSection && YGAnchorItem.observer) {
          YGAnchorItem.sectionToItem.delete(this.#observedSection);
          YGAnchorItem.observer.unobserve(this.#observedSection);
        }
      }

      static #ensureObserver() {
        if (YGAnchorItem.observer) return;

        YGAnchorItem.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = YGAnchorItem.sectionToItem.get(entry.target);
              if (!YGAnchorItem.isScroll) {
                item && item.setActiveFromObserver();
              }
            });
          },
          {
            root: null,
            threshold: 0.01,
            rootMargin: '-20% 0px -70% 0px',
          }
        );
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) {
            this.labelClick(index);
          }
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick(index) {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        const sectionNumber = this.getAttribute('data-section-number');
        YGAnchorItem.isScroll = true;
        this.setActiveFromObserver();
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = this.sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-count-down"] && !Shopify.designMode) return;
  try {
    class YGCountDown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.hasExpired = false;
    }

    connectedCallback() {
      this.targetDate = this.parseDate(this.dataset.date);

      if (!this.targetDate) {
        this.hidden = true;
        return;
      }

      this.updateCountdown();

      if (!this.hasExpired) {
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      this.clearTimer();
    }

    parseDate(rawDate) {
      if (!rawDate) return null;

      const normalizedDate = rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/');
      const parsedDate = new Date(normalizedDate);

      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    clearTimer() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    get itemMap() {
      if (this._itemMap) return this._itemMap;

      this._itemMap = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };

      return this._itemMap;
    }

    updateCountdown() {
      const diff = this.targetDate.getTime() - Date.now();

      if (diff <= 0) {
        this.handleExpiration();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.renderValue(this.itemMap.days, days);
      this.renderValue(this.itemMap.hours, hours);
      this.renderValue(this.itemMap.minutes, minutes);
      this.renderValue(this.itemMap.seconds, seconds);
    }

    renderValue(element, value) {
      if (!element) return;
      element.textContent = String(value).padStart(2, '0');
    }

    handleExpiration() {
      if (this.hasExpired) return;

      this.hasExpired = true;
      this.clearTimer();

      if (this.dataset.endAction === 'hide_block' && this.dataset.blockId) {
        this.dispatchEvent(
          new CustomEvent('yg:announcement-block-expired', {
            bubbles: true,
            detail: {
              blockId: this.dataset.blockId
            }
          })
        );
        return;
      }

      this.hidden = true;
    }
  }

  (() => {
    const boot = () => {
      if (!window.customElements.get('yg-count-down')) {
        window.customElements.define('yg-count-down', YGCountDown);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
      #dropdownGroup;
      static #groupRegistry = new Map();

      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this.debouncedResize = this.debounce(() => this.setContentContainerHeight(), 100);
      }

      #manageGroupRegistry(action) {
        const groupID = this.dataset.group
        if (!groupID) return action === 'get' ? null : undefined

        switch (action) {
          case 'add':
            if (!YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.set(groupID, new Set())
            }
            YGDropdown.#groupRegistry.get(groupID).add(this)
            break
          case 'remove':
            if (YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.get(groupID).delete(this)
            }
            break
          case 'get':
            const groupDropdowns = YGDropdown.#groupRegistry.get(groupID)
            this.#dropdownGroup = groupDropdowns ? Array.from(groupDropdowns) : null
            return this.#dropdownGroup
        }
      }

      get dropdownGroup() {
        if (this.#dropdownGroup) return this.#dropdownGroup
        return this.#manageGroupRegistry('get')
      }

      connectedCallback() {
          this.#manageGroupRegistry('add')

          setTimeout(() => {
            if (this.dropdownGroup?.length > 0) {
              this.dropdownGroup[0]?.openDropdown();
            }
          }, 60);
          this.titleContainer = this.querySelector('.yg-dropdown-title-container');
          if (this.titleContainer) {
            this.titleContainer.addEventListener('click', this.itemClick);
            window.addEventListener('resize', this.debouncedResize);
            this.setContentContainerHeight()
          }
      }

      disconnectedCallback() {
          this.#manageGroupRegistry('remove')

          if (this.titleContainer) {
            this.titleContainer.removeEventListener('click', this.itemClick);
          }
          if (this.debouncedResize) {
            window.removeEventListener('resize', this.debouncedResize);
          }
      }
      itemClick() {
          this.setContentContainerHeight();
          let group = this.dropdownGroup;
          if (group && Array.isArray(group) && this.hasAttribute('open')) {
            if (!this.hasAttribute('data-accordion') && group.length > 1) {
              this.closeDropdown();
            }
            return;
          }
   
          this.hasAttribute('open')?this.closeDropdown():this.openDropdown();
      }

      openDropdown(){
        let group = this.dropdownGroup;
        if (group && Array.isArray(group)) {
            group.forEach(dropdown => {
                if (dropdown !== this) {
                    dropdown.closeDropdown();
                }
            });
        }
   
        this.setAttribute('open', '');
        document.dispatchEvent(new CustomEvent('YG:dropdown-open', {
          bubbles: true,
          composed: true,
          detail: {
            id: this.getAttribute('data-id')
          }
        }));
      }

      closeDropdown(){
        this.removeAttribute('open');
      }

      setContentContainerHeight(){
        let contentContainer = this.querySelector('.yg-dropdown-content-container');
        let content = this.querySelector('.yg-dropdown-content');
        if (contentContainer && content) {
          contentContainer.style.setProperty('--height', `${content.getBoundingClientRect().height}px`);
        }
      }
  }
  if (!window.customElements.get('yg-dropdown')) {
      window.customElements.define('yg-dropdown',YGDropdown)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-mega-menu-mobile"] && !Shopify.designMode) return;
  try {
    class YGMegaMenuMobile extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.views = Array.from(this.querySelectorAll('[data-yg-mobile-view]'));
    this.openButtons = Array.from(this.querySelectorAll('[data-yg-open-view]'));
    this.backButtons = Array.from(this.querySelectorAll('[data-yg-back-view]'));
    this.groups = Array.from(this.querySelectorAll('.yg-mega-menu-mobile__group'));
    this.groupButtons = Array.from(this.querySelectorAll('[data-yg-group-toggle]'));

    this.openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.showView(button.dataset.ygOpenView);
      });
    });

    this.backButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.showView(button.dataset.ygBackView);
      });
    });

    this.groupButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const currentGroup = button.closest('.yg-mega-menu-mobile__group');
        const parentGroups = currentGroup ? currentGroup.closest('.yg-mega-menu-mobile__groups') : null;

        if (!currentGroup || !parentGroups) return;

        Array.from(parentGroups.children).forEach((group) => {
          const isActive = group === currentGroup ? !group.classList.contains('is-active') : false;
          const trigger = group.querySelector('[data-yg-group-toggle]');

          group.classList.toggle('is-active', isActive);

          if (trigger) {
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          }
        });
      });
    });
  }

  showView(viewId) {
    if (!viewId) return;

    this.views.forEach((view) => {
      view.classList.toggle('is-active', view.dataset.ygMobileView === viewId);
    });
  }
}

if (!window.customElements.get('yg-mega-menu-mobile')) {
  window.customElements.define('yg-mega-menu-mobile', YGMegaMenuMobile);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.parentTriggers = Array.from(
        this.querySelectorAll("[data-yg-parent-tab]")
      );
      this.parentPanels = Array.from(
        this.querySelectorAll(".yg-mega-menu__parent-panel")
      );
      this.triggers = Array.from(
        this.querySelectorAll("[data-yg-product-tab]")
      );
      this.panels = Array.from(
        this.querySelectorAll("[data-yg-product-panel]")
      );

      if (!this.triggers.length || !this.panels.length) return;

      const activeParent =
        this.parentPanels.find((parentPanel) =>
          parentPanel.classList.contains("is-active")
        ) || this.parentPanels[0];

      if (activeParent) {
        this.activateParent(activeParent);
      }

      const activeTrigger =
        this.triggers.find((trigger) =>
          trigger.classList.contains("is-active")
        ) || this.triggers[0];

      this.activatePanel(activeTrigger.dataset.ygProductTab);

      this.parentTriggers.forEach((trigger) => {
        trigger.addEventListener("focus", () => {
          this.activateParentFromTrigger(trigger);
        });

        trigger.addEventListener("click", () => {
          this.activateParentFromTrigger(trigger);
        });
      });

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("focus", () => {
          this.activatePanel(trigger.dataset.ygProductTab);
        });

        trigger.addEventListener("click", () => {
          this.activatePanel(trigger.dataset.ygProductTab);
        });
      });
    }

    activateParentFromTrigger(trigger) {
      const parentPanel = trigger.closest(".yg-mega-menu__parent-panel");
      if (!parentPanel) return;

      this.activateParent(parentPanel);

      const activeChild =
        parentPanel.querySelector("[data-yg-product-tab].is-active") ||
        parentPanel.querySelector("[data-yg-product-tab]");

      if (activeChild) {
        this.activatePanel(activeChild.dataset.ygProductTab);
      }
    }

    activateParent(parentPanel) {
      this.parentPanels.forEach((item) => {
        const isActive = item === parentPanel;
        const trigger = item.querySelector("[data-yg-parent-tab]");

        item.classList.toggle("is-active", isActive);
        if (trigger) {
          trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        }
      });
    }

    activatePanel(panelId) {
      if (!panelId) return;

      this.triggers.forEach((trigger) => {
        trigger.classList.toggle(
          "is-active",
          trigger.dataset.ygProductTab === panelId
        );
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle(
          "is-active",
          panel.dataset.ygProductPanel === panelId
        );
      });
    }
  }

  if (!window.customElements.get("yg-mega-menu")) {
    window.customElements.define("yg-mega-menu", YGMegaMenu);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-coupon-01"] && !Shopify.designMode) return;
  try {
    class YGProductCoupon01 extends HTMLElement {
    constructor() {
      super();
      this.handleExpiration = this.handleExpiration.bind(this);
    }

    connectedCallback() {
      this.addEventListener('yg:announcement-block-expired', this.handleExpiration);
    }

    disconnectedCallback() {
      this.removeEventListener('yg:announcement-block-expired', this.handleExpiration);
    }

    handleExpiration(event) {
      if (!event.detail || !event.detail.blockId || this.dataset.blockId !== event.detail.blockId) return;

      const blockItem = this.closest('.product-info__block-item');

      if (blockItem) {
        blockItem.hidden = true;
        return;
      }

      this.hidden = true;
    }
  }

  if (!window.customElements.get('yg-product-coupon-01')) {
    window.customElements.define('yg-product-coupon-01', YGProductCoupon01);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-coupon-code-01"] && !Shopify.designMode) return;
  try {
    class YGProductCouponCode01 extends HTMLElement {
    constructor() {
      super();
      this.copyTimeout = null;
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.copyTrigger = this.querySelector('[data-copy-trigger]');
      this.statusElement = this.querySelector('[data-copy-status]');

      if (this.copyTrigger) {
        this.copyTrigger.addEventListener('click', this.handleClick);
      }

      this.labelElement = this.querySelector('.yg-product-coupon-code-01__label');
      this.defaultLabel = this.labelElement ? this.labelElement.textContent : '';
    }

    disconnectedCallback() {
      if (this.copyTrigger) {
        this.copyTrigger.removeEventListener('click', this.handleClick);
      }

      if (this.copyTimeout) {
        window.clearTimeout(this.copyTimeout);
      }
    }

    async handleClick() {
      if (!this.dataset.discountCode) {
        this.showFeedback(this.dataset.copyErrorText || 'Copy failed');
        return;
      }

      const copied = await this.copyText(this.dataset.discountCode);

      if (copied) {
        this.showFeedback(this.dataset.copySuccessText || 'Copied', true);
        return;
      }

      this.showFeedback(this.dataset.copyErrorText || 'Copy failed');
    }

    async copyText(value) {
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(value);
          return true;
        } catch (error) {
        }
      }

      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      const copied = document.execCommand('copy');
      document.body.removeChild(textarea);

      return copied;
    }

    showFeedback(message, copied = false) {
      if (this.copyTimeout) {
        window.clearTimeout(this.copyTimeout);
      }

      if (this.labelElement) {
        this.labelElement.textContent = message;
      }

      if (this.statusElement) {
        this.statusElement.textContent = message;
      }

      if (copied) {
        this.dataset.copied = 'true';
      } else {
        this.removeAttribute('data-copied');
      }

      this.copyTimeout = window.setTimeout(() => {
        if (this.labelElement) {
          this.labelElement.textContent = this.defaultLabel;
        }

        if (this.statusElement) {
          this.statusElement.textContent = '';
        }

        this.removeAttribute('data-copied');
      }, 3000);
    }
  }

  if (!window.customElements.get('yg-product-coupon-code-01')) {
    window.customElements.define('yg-product-coupon-code-01', YGProductCouponCode01);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-progress-bar"] && !Shopify.designMode) return;
  try {
    class YGProgressBar extends HTMLElement {
    #videoListenersAttached = false;

    constructor() {
      super();
      this.video = null;
      this.animationFrame = null;
    }

    connectedCallback() {
    }

    get isCircle() {
      return this.classList.contains('yg-progress-circle');
    }

    get circleProgressElement() {
      return this.querySelector('.circle-progress');
    }

    findVideo() {
      let isMobile = window.innerWidth < 699;
      let id = this.getAttribute('data-id');
      if (isMobile && this.getAttribute('data-mobile-id')) {
        id = this.getAttribute('data-mobile-id');
      }
      if (!id) return null;

      return document.querySelector(`yg-video[data-id="${id}"]`);
    }

    getVideoElement(videoComponent) {
      if (!videoComponent) return null;
      return videoComponent.querySelector('.yg-video-iframe');
    }

    syncWithVideo() {
      if (!this.video) return;

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) return;

      const duration = this.video.duration || videoEl.duration || 0;
      const currentTime = videoEl.currentTime || 0;

      if (duration > 0) {
        const progress = (currentTime / duration) * 100;
        
        if (this.isCircle) {
          this.syncCircleProgress(progress);
        } else {
          this.style.setProperty('--progress-width', `${progress}%`);
        }
      }
    }

    syncCircleProgress(progress) {
      const circleEl = this.circleProgressElement;
      if (!circleEl) return;

      const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
      const dashArray = (progress / 100) * circumference;
      circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
    }

    startProgress() {
      const id = this.getAttribute('data-id');
      this.video = this.findVideo();

      if (this.video) {
        this.startVideoProgress();
      } else {
        this.startAnimationProgress();
      }
    }

    startAnimationProgress() {
      const id = this.getAttribute('data-id');
      this.classList.add('start-progress');

      if (this.isCircle) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const style = getComputedStyle(this);
          const duration = parseFloat(style.getPropertyValue('--duration')) || 10;
          const circumference = parseFloat(style.getPropertyValue('--circle-circumference')) || 100;
          
          let startTime = null;
          
          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = (timestamp - startTime) / 1000;
            const progress = Math.min(elapsed / duration, 1);
            
            const dashArray = progress * circumference;
            circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
            
            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(animate);
            } else {
              this.stopProgress(true);
            }
          };
          
          this.animationFrame = requestAnimationFrame(animate);
        }
        return;
      }

      let handleAnimationEnd = () => {
        this.stopProgress(true);
        this.removeEventListener('animationend', handleAnimationEnd);
      };

      this.addEventListener('animationend', handleAnimationEnd);
    }

    startVideoProgress() {
      this.classList.add('video-sync');

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) {
        this.#waitForVideo();
        return;
      }

      this.#initVideoListeners(videoEl);

      if (!videoEl.paused) {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      }
    }

    #waitForVideo() {
      const observer = new MutationObserver(() => {
        const videoEl = this.getVideoElement(this.video);
        if (videoEl) {
          observer.disconnect();
          this.#initVideoListeners(videoEl);
          if (!videoEl.paused) {
            this.classList.add('playing');
            this.#startVideoUpdate(videoEl);
          }
        }
      });
      observer.observe(this.video, { childList: true, subtree: true });
    }

    #initVideoListeners(videoEl) {
      if (this.#videoListenersAttached) return;
      this.#videoListenersAttached = true;

      videoEl.addEventListener('play', () => {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      });

      videoEl.addEventListener('pause', () => {
        this.classList.remove('playing');
        this.#stopVideoUpdate();
      });

      videoEl.addEventListener('ended', () => {
        this.stopProgress(true);
      });

      videoEl.addEventListener('timeupdate', () => {
        this.syncWithVideo();
      });
    }

    #startVideoUpdate(videoEl) {
      this.#stopVideoUpdate();
      const updateProgress = () => {
        this.syncWithVideo();
        if (!videoEl.paused && !videoEl.ended) {
          this.animationFrame = requestAnimationFrame(updateProgress);
        }
      };
      updateProgress();
    }

    #stopVideoUpdate() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    }

    stopProgress(completed = false) {
      this.classList.remove('start-progress', 'playing', 'video-sync');

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      if (this.isCircle && !completed) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
          circleEl.style.strokeDasharray = `0 ${circumference}`;
        }
      }

      if (completed) {
        const id = this.getAttribute('data-id');
        document.dispatchEvent(new CustomEvent('YG:progress-end', {
          bubbles: true,
          composed: true,
          detail: { id }
        }));
      }
    }
  }

  if (!window.customElements.get('yg-progress-bar')) {
    window.customElements.define('yg-progress-bar', YGProgressBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', ()=>this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }

      // Idle warmup for HTML5 <video> only (skip iframes) to improve first play without blocking main thread.
      this.scheduleHtml5VideoWarmup();
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState("play")
      if (!this.videoContainer) {
        this.appendChild(this.template?.content.cloneNode(true));
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach(video => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (
              video.duration &&
              video.currentTime >= video.duration &&
              this.loop == 'false'
            ) {
              this.pauseVideo();
              this.switcherVideoButtonState("pause");
            }
          });
        });
      }

      
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState("pause")
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach(video => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState (state = "play") {
      if (state == "pause") {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == "play") {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Schedule work in idle time to avoid competing with main thread.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 1200);
      }
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
